<template>
    <div class="video-recorder">
        <div v-if="recoderStatus" class="video-recorder-wapper" :id="getId"></div>
    </div>
</template>

<script>
import EZUIKit from "ezuikit-js";
var debounce = (fn, wait, immediate = false) => {
    let timer, startTimeStamp = 0;
    let context, args;

    let run = timerInterval => {
        timer = setTimeout(() => {
            let now = new Date().getTime();
            let interval = now - startTimeStamp;
            if (interval < timerInterval) {
                // the timer start time has been reset，so the interval is less than timerInterval
                console.log("debounce reset", timerInterval - interval);
                startTimeStamp = now;
                run(wait - interval); // reset timer for left time
            } else {
                if (!immediate) {
                    fn.apply(context, args);
                }
                clearTimeout(timer);
                timer = null;
            }
        }, timerInterval);
    };

    return function() {
        context = this;
        args = arguments;
        let now = new Date().getTime();
        startTimeStamp = now; // set timer start time

        if (!timer) {
            console.log("debounce set", wait);
            if (immediate) {
                fn.apply(context, args);
            }
            run(wait); // last timer alreay executed, set a new timer
        }
    };
};
import getRandom from "./tools/getNoRepeatNum.js";
export default {
    props: ["hideBtnList", "array", "propSplitBasis"],
    data() {
        return {
            splitBasis: null,
            player: null,
            recoderStatus: true,
            errorTime: 0
        };
    },
    beforeDestroy() {
        this.destroyRecoder();
        window.removeEventListener("error", this.headerOtherError);
    },
    computed: {
        getId() {
            return "videoRecorder" + getRandom(10);
        }
    },
    methods: {
        popError: debounce(
            function() {
                this.$Message.destroy();
                this.$Message.error("无法与摄像头建立连接，可刷新或切换其他画面");
            },
            100,
            true
        ),
        headerOtherError(e) {
            var intervalMin = 1;
            let lastTime = localStorage.getItem("lastReloadTime");
            let nowTime = new Date().getTime();
            localStorage.setItem("lastReloadTime", nowTime);
            if (lastTime) {
                if (nowTime - lastTime <= intervalMin * 60 * 1000) {
                    this.popError();
                    return;
                }
            }
            location.reload();
        },
        headerError(e) {
            if (e.errorType && e.errorType == 1) {
                this.errorTime = this.errorTime + 1;
                if (this.errorTime >= 5) {
                    this.errorTime = 0;
                    this.headerOtherError();
                } else {
                    this.initCompent();
                }
            }
            console.error(e);
        },
        destroyRecoder() {
            try {
                this.player && this.player.stop();
            } catch (e) {
                //TODO handle the exception
            }
            try {
                this.player && this.player.destroy() && (this.player = null);
            } catch (e) {
                //TODO handle the exception
            }
            this.recoderStatus = false;
            this.$nextTick(function() {
                this.recoderStatus = true;
            });
        },
        initRecorder(id, options) {
            try {
                let player = new EZUIKit.EZUIKitPlayer(
                    Object.assign(
                        {},
                        {
                            id: id,
                            autoplay: true,
                            audio: 0,
                            handleError: error => {
                                this.headerError(error);
                            },
                            handleSuccess: () => {}
                        },
                        options
                    )
                );
                this.player = player;
            } catch (e) {
                console.log(e);
            }
        },
        initCompent() {
            let array = this.array;
            if (array.length == 0) {
                return;
            }
            let splitBasis =
                this.propSplitBasis || (array.length == 1 ? 1 : array.length <= 4 ? 4 : 9);
            this.splitBasis = splitBasis;
            this.initRecorder(this.getId, {
                url: array
                    .map(item => item.ezopen)
                    .join(","),
                splitBasis,
                accessToken: array[0].accessToken
            });
        }
    },
    mounted() {
        // window.addEventListener('error',this.headerOtherError)
        this.initCompent();
    }
};
</script>
<style scoped="scoped">
.recorder-btn-list > div {
    display: flex;
    align-items: center;
}
.grid-9 > div::after {
    content: " ";
    position: absolute;
    width: 100%;
    height: 8px;
    border: 2px solid;
    border-left: 0;
    border-right: 0;
    top: 50%;
    transform: translateY(-50%);
}
.grid-9 > div::before {
    content: " ";
    position: absolute;
    height: 100%;
    width: 8px;
    border: 2px solid;
    border-top: 0;
    border-bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}
.grid-4 > div::after {
    content: " ";
    position: absolute;
    background: currentcolor;
    width: 100%;
    height: 2px;
    top: 50%;
    transform: translateY(-50%);
}
.grid-4 > div::before {
    content: " ";
    position: absolute;
    background: currentcolor;
    height: 100%;
    width: 2px;
    left: 50%;
    transform: translateX(-50%);
}
.grid-btn > div {
    position: relative;
    color: #fff;
    width: 60%;
    height: 60%;
    border: 2px solid;
}
.grid-btn.active {
    background: #01abff;
}
.grid-btn {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    width: 30px;
    height: 30px;
    border-radius: 5px;
}
svg {
    cursor: pointer;
    height: 20px;
    width: 20px;
    color: #fff;
}
.recorder-btn-list {
    display: none;
    z-index: 1;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
}
.recorder-btn-list:hover .recorder-btn-list,
.video-recorder-wapper:hover .recorder-btn-list,
.video-recorder:hover .recorder-btn-list {
    display: flex;
    transition: all 1s;
}
.video-recorder-wapper {
    height: 100% !important;
    width: 100% !important;
    position: relative;
    /* box-sizing: content-box; */
}
.video-recorder {
    overflow: hidden;
    padding: 0px;
    position: relative;
    height: 100%;
    background: #000;
}
</style>
